import { Section } from "src/lib"
import { PriorityListIcon } from "src/lib/icons"
import intl from "src/internationalization/intl"
import { AdvisorRankingsPreview } from "./AdvisorRankingsPreview"

/**
 * Seção independente (sem expansão) que expõe os critérios de priorização
 * usados para ordenar as sugestões de investimento. Read-only — aparece acima
 * dos Compromissos no painel do assessor.
 */
const PrioritizationCriteriaSection = () => (
    <Section
        title={intl("rankingSectionTitle")}
        subtitle={intl("rankingSectionSubtitle")}
        icon={<PriorityListIcon />}
    >
        <AdvisorRankingsPreview />
    </Section>
)

export { PrioritizationCriteriaSection }
